<template>
	<div class="website-enquiry">
		<filter-panel :data="groups" @search="filterChange"></filter-panel>
		<data-list
			:table-style="{ name: 'mixture' }"
			:data="data"
			:columns="column"
			:loading="loading"
			:page="page"
			:page-size="page.pageSize"
			@page-size-changed="pageSizeChanged"
			@page-changed="pageChanged"
			@sort-change="sortChange"
		></data-list>

		<!-- 二次审核弹窗 -->
		<secondReview
			ref="secondReview"
			:idList="unreviewedIdList"
			@changePage="changePage"
			@query="query"
		></secondReview>
	</div>
</template>

<script>
import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel.vue';
import api from '@/backend/apiConfig/apiConfig';
import listPageCreate from '@/mixins/listPageCreate';
import customer from '@/mixins/customer';
import {
	inquirysource,
	sitePlatform,
	garbageEnquiries,
	osOptions,
	secondReviewOptions,
} from '@/common/dictionary.js';
import enquiry from '@/backend/services/enquiry/enquiry.js';
import beforeRouteEnter from '@/mixins/beforeRouteEnter.js';
import grabageEnquiryType from '@/components/enquiry/grabageEnquiryType.vue';
import secondReview from './components/secondReview.vue';

const list = listPageCreate({
	searchConfig: {
		api: api.inquiry.inquirypcpage,
		method: 'POST',
	},
});
export default {
	name: 'enquiry',
	components: { filterPanel, secondReview },
	mixins: [list, customer, beforeRouteEnter],
	data() {
		let that = this;
		const groups = {
			others: [
				{
					tagName: 'sky-select',
					placeholder: '主域名',
					label: '主域名',
					prop: 'serviceSiteId',
					value: '',
					props: {
						label: 'domain',
						value: 'serviceSiteId',
					},
					filterable: true,
					remote: true,
					'remote-method': function (val) {
						enquiry.getwebsiteorder(val).then(res => {
							that.groups.others[0].options = res.data;
						});
					},
					options: [],
				},
				{
					label: '时间',
					startPlaceholder: '开始日期',
					endPlaceholder: '结束日期',
					prop: ['beginTimeStr', 'endTimeStr'],
					tagName: 'sky-date-picker',
					type: 'daterange',
					value: [],
				},
			],
			multiples: [
				{
					defaultText: '询盘来源',
					placeholder: '询盘来源',
					label: '询盘来源',
					options: inquirysource,
					prop: 'inquiryType',
					value: '',
				},
				{
					defaultText: '建站平台',
					placeholder: '建站平台',
					label: '建站平台',
					options: sitePlatform,
					prop: 'sitePlatform',
					value: '',
				},
				{
					defaultText: '询盘筛选',
					placeholder: '询盘筛选',
					label: '询盘筛选',
					options: garbageEnquiries,
					prop: 'filterFlag',
					value: '',
				},
				{
					defaultText: '设备',
					placeholder: '设备',
					label: '设备',
					options: osOptions,
					prop: 'os',
					value: '',
				},
				{
					defaultText: '二次审核',
					placeholder: '二次审核',
					label: '二次审核',
					options: secondReviewOptions,
					prop: 'reviewStatus',
					value: '',
				},
			],
		};
		const column = [
			{
				label: '客户名称',
				bind: 'custName',
			},
			{
				label: '建站平台',
				bind: 'sitePlatform',
				type: 'percentage',
				dataStyle(val) {
					return (val == 1 && '建站供应商') || (val == 2 && '外贸云建站');
				},
			},
			{
				type: 'custInfo',
				label: '域名',
				text: [
					{
						bind: 'domianName',
					},
				],
			},
			{
				label: '留言时间',
				bind: 'submitTimeStr',
			},
			{
				label: '地区',
				bind: 'region',
			},
			{
				label: '设备',
				bind: 'os',
			},
			{
				label: '来源',
				bind: 'inquiryTypeStr',
				type: 'custom',
				componentName: grabageEnquiryType,
				message(row) {
					let { filterRemarks } = row;
					return filterRemarks;
				},
				iconName: 'jinggao',
				iconStyle: {
					color: 'red',
				},
				showIcon(row) {
					let { isFilter } = row;
					return isFilter === 1;
				},
			},
			{
				label: '二次审核',
				bind: row => {
					let { reviewStatus } = row;
					switch (reviewStatus) {
						case 0:
							return '未审核';
						case 1:
							return '已审核';
						case 2:
							return '客户审核';
						case 3:
							return '不需要审核';
						default:
							return '-';
					}
				},
				width: 100,
				getClass(row) {
					let { reviewStatus } = row;
					switch (reviewStatus) {
						case 0:
							return 'danger';
						case 1:
						case 2:
							return 'normalText';
						case 3:
							return 'deathText';
						default:
							return 'deathText';
					}
				},
			},
			{
				label: '留言内容',
				bind: 'message',
				type: 'popoverView',
			},
			{
				label: '归因',
				content:
					'由于GA4尚不稳定，数据拉取存在延迟，会出现不及时或有更新的情况，溯源匹配规则说明如下：</br>1、系统每天早中晚多次进行归因匹配，每次回溯周期为过去7天</br>2、回溯周期内，未匹配的询盘，会显示“识别中”，直到超过周期后显示“未匹配到归因信息”</br>3、一般来说，今天看前天的数据时，已经是最终结果</br></br>当归因中显示“无”或“未提供”时，有多种情况，除系统未识别以外，常见的情况有：</br>1、媒介中显示“无”：本身无媒介，如直接访问</br>2、广告系列显示“无”：表示非付费广告</br>3、关键词显示“无”：广告系列为展示广告，无关键词</br>4、关键词显示“未提供”：搜索引擎出于隐私考虑，未提供自然搜索的关键词',
				bind: 'source',
				type: 'multiRowPopover',
				multiRowCon(val, row) {
					if (row.inquiryType === 4 || row.inquiryType === 5) {
						switch (row.identifiedStatus) {
							case 0:
								return '识别中';
							case 1:
								return '未记录到访客ID';
							case 2:
								return '未匹配到归因信息';
							case 4:
								return '未查询到归因信息';
							case 5:
								return 'Facebook广告';
							case 6:
								return '公共主页';
						}
						if (row) {
							return `${row.source || '-'}${row.adSeries ? '-' + row.adSeries : '-'}${
								row.keyword ? '-' + row.keyword : '-'
							}`;
						} else {
							return '- ';
						}
					} else if (row.inquiryType === 7) {
						if (row.mediumDetailsId == '405003') {
							return row.mediumDetailsName;
						} else {
							return row.campaignName ? row.campaignName : '-';
						}
					} else {
						return '- ';
					}
				},
				disabled(row) {
					if (row.identifiedStatus !== 3) return true;
					if (row.inquiryType === 4) return false;
					if (row.inquiryType === 5) return false;
					if (row.inquiryType === 7 && row.mediumDetailsId !== 405003) return false;
					return true;
				},
				dialogList(val, row) {
					if (!row) return [];
					if (row) {
						if (row.inquiryType === 7 && row.mediumDetailsId !== 405003) {
							return [
								{
									label: '广告系列：',
									value: row.campaignName || '-',
								},
								{
									label: '广告组：',
									value: row.adsetName || '-',
								},
								{
									label: '广告：',
									value: row.adName || '-',
								},
							];
						} else {
							return [
								{
									label: '来源/媒介：',
									value: row.source || '-',
								},
								{
									label: '广告系列：',
									value: row.adSeries || '-',
								},
								{
									label: '关键字：',
									value: row.keyword || '-',
								},
							];
						}
					} else {
						return [];
					}
				},
			},
			{
				label: '操作',
				type: 'btnClick',
				align: 'center',
				verticalAlign: true,
				style: 'text',
				minWidth: '80',
				bind: [
					{
						text: '查看',
						showButton() {
							return that.getPermission(that.$permissionData.ViewDetail.englishName);
						},
						trigger: row => {
							that.$router.push({
								name: 'enquiry_detail',
								query: {
									id: row.tableId,
									inquiryType: row.inquiryType,
								},
							});
						},
					},
					{
						text: '审核',
						showButton(row) {
							let { reviewStatus } = row;
							return (
								reviewStatus !== null &&
								reviewStatus !== 3 &&
								that.getPermission('inquiryListAudit')
							);
						},
						trigger: row => {
							let { summaryId } = row;
							that.$refs.secondReview.openDialog(summaryId);
						},
					},
				],
			},
		];
		return {
			groups: groups,
			column: column,
		};
	},
	computed: {
		// 需要审核ID列表
		unreviewedIdList(self) {
			let { data } = self;
			return data.filter(item => item.reviewStatus !== null).map(item => item.summaryId);
		},
	},
	methods: {
		// 翻页操作
		async changePage() {
			let { page } = this;
			let { currentPage, pageSize, totalRecords } = page;
			if (currentPage === Math.ceil(totalRecords / pageSize)) {
				this.$refs.secondReview.closeDialog();
				return;
			}
			this.page.currentPage += 1;
			await this.query();
			setTimeout(() => {
				if (this.unreviewedIdList.length === 0) this.changePage();
				else this.$refs.secondReview.reset();
			});
		},
	},
};
</script>

<style scoped lang="scss">
.inquiry-export {
	height: 60px;
	display: flex;
	justify-content: flex-end;
	align-items: center;
	padding: 0 20px;
}
</style>
